/**
 * LoansPanel — every transaction flagged is_loan=true. Cumulative view for
 * reimbursement tracking. Renders the same table + summary as Personal/
 * Unknown so operators have a consistent workflow.
 */
import { Landmark } from "lucide-react";
import FlaggedPanel from "./FlaggedPanel";

export default function LoansPanel(props) {
  return (
    <FlaggedPanel
      {...props}
      filter={{ is_loan: true }}
      title="Loans — reimbursement tracker"
      subtitle="Every row you've flagged as a loan disbursement or repayment."
      icon={Landmark}
      iconBgClass="bg-brand-teal"
      totalLabel="Net loan balance"
      testidPrefix="ops-loans"
      loadErrorText="Failed to load loan transactions"
      emptyIcon={Landmark}
      emptyTitle="No loans flagged"
      emptyBody={<>In the Review tab, toggle <span className="font-semibold text-brand-navy">Is this a loan?</span> on any row you owe or paid so it shows up here.</>}
    />
  );
}
